import {
	FilteredEvent,
} from "./types";

/**
 * Helper function for formatting the event title correctly for display.
 * This is used to support the type in a different column feature
 * @param event The event to format the title.
 * @param showServerEventTitle If the result should contain event.serverEventTitle.
 * @returns If the showServerEventTitle is false, it will strip event.serverEventTitle from event.eventTitle.
 * If the event has a response it will concatenate it with event.eventTitle and return that.
 */
export const setDisplayTitle = (event:FilteredEvent, showServerEventTitle: boolean) : string => {
    // If the showServerEventTitle the event.serverEventTitle will be shown in a 'Type' separate column
    // However in some circumstance the eventTitle cam contain the serverEventTitle
    //      event.EventTitle = "SomeValue - Active Shooter"
    //      event.ServerEventTitle = "Active Shooter"
    // So If the feature is enabled then check to see if it does and if so remove it

	const displayEventTitle: string = showServerEventTitle
		? event.eventTitle
		: event.eventTitle.replace( " - " + event.serverEventTitle, "").replace(event.serverEventTitle, "");

	if (event.eventTitle === "") {
		return event.responseTitle;
	} else if (event.responseTitle === "") {
		// displayEventTitle can be "" if event.eventTitle == event.serverEventTitle
		return displayEventTitle ? displayEventTitle : event.eventTitle;
	} else {
		return `${displayEventTitle ? displayEventTitle + " - " : displayEventTitle}${event.responseTitle}`;
	}
};
